import React from "react";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useOutletContext, useNavigate } from "react-router-dom";
import LeaderboardSecton from "../components/Other/LeaderboardSecton";

const LeaderBoardPage = () => {
  
  const [sidebarToggle] = useOutletContext();

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title="Leaderboard" />
      <LeaderboardSecton />
    </>
  );
};

export default LeaderBoardPage;